import marketTypeTradingEligibilityService from '@exchange/libs/account/service/src/lib/market-type-trading-eligibility.service';
import { futuresService } from '@exchange/libs/futures/service/src';
import { toastManagerInstance } from '@exchange/libs/toasts/src';
import SimpleToast from '@exchange/libs/toasts/src/lib/ui/SimpleToast.vue';
import { capIsNativePlatform } from '@exchange/libs/utils/capacitor/src';
import handleNativeGoTo from '@exchange/libs/utils/capacitor/src/lib/handle-native-go-to';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import { logger } from '@exchange/libs/utils/simple-logger/src';

const useFuturesAssessmentGoTo = () => {
  const defaultUrl = `${process.env.VUE_APP_ACCOUNTS_URL}${CONSTANTS.FUTURES_PATHNAME}`;

  const refetchFuturesAssessmentData = async () => {
    try {
      await Promise.all([
        futuresService.refetchClientCategorisation(),
        futuresService.refetchFuturesAppropriatenessAssessment(),
        futuresService.refetchLeverage(),
        marketTypeTradingEligibilityService.refetchMarketTypeTradingEligibility(),
      ]);
    } catch (error) {
      logger.error('Failed to refetch futures assessment data', error);
    }
  };

  const goToAssessment = (url = defaultUrl, onNativeGoTo?: VoidFunction) => {
    if (capIsNativePlatform()) {
      handleNativeGoTo(url, refetchFuturesAssessmentData, () => {
        toastManagerInstance.addToast({
          content: SimpleToast,
          props: {
            variant: 'failed',
            title: 'fundamentals.toasts.failed',
            message: 'fundamentals.error.text',
          },
        });
      });
      onNativeGoTo?.();
    } else {
      window.location.href = url;
    }
  };

  return {
    goToAssessment,
  };
};

export default useFuturesAssessmentGoTo;
